import { Injectable } from '@angular/core';
import { Restaurant } from '../models/restaurant.model';

@Injectable({
  providedIn: 'root',
})
export class RestaurantService {
  private restaurants: Restaurant[] = [
    {
      name: '0000001',
    },
  ];

  getRestaurants(): Restaurant[] {
    return this.restaurants;
  }
}
